import { ModuleWithProviders, NgModule } from '@angular/core';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { CONTACT_CONFIG } from './providers/contact_config_provider.token';

@NgModule({
  imports: [ContactFormComponent],
  exports: [ContactFormComponent],
})
export class ContactModule {
  static forRoot(config: any): ModuleWithProviders<ContactModule> {
    return {
      ngModule: ContactModule,
      providers: [
        {
          provide: CONTACT_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
